import * as React from "react";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { BackOfficeProvider } from "../../../../../../../Wrap/Models/Models/BackOfficeIntegration/BackOfficeProvider";
import { AcornCommissionSettings } from "../../../../../../../Wrap/Models/Models/Company/AcornCommissionSettings";
import { BackOfficeProviderSettings } from "../../../../../../../Wrap/Models/Models/Company/BackOfficeProviderSettings";
import { FileFormat } from "../../../../../../../Wrap/Models/Models/Company/FileFormat";
import { ValidatorContents } from "../../../../../../Dashboard/Common/ValidatorHelper";
import { SectionHeader } from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Table } from "../../../../../../Shared/Table/Table";
import { CompanyWizardAction } from "../../../Actions/CompanyWizardAction";
import { BackOfficeProvidersStore } from "../../../Stores/Variable";
import { BackOfficeSettings } from "./BackOfficeSettings";

interface IBackOfficeProps extends IProcessComponentProps {
    data: BackOfficeProviderSettings[];
    acornCommissionSettings?: AcornCommissionSettings;
    onChange: (changes: BackOfficeProviderSettings[]) => void;
    onRef: (ref) => void;
    isReview: boolean;
}

interface IBackOfficeState {
    providers: BackOfficeProvider[];
    currentSetting: BackOfficeProviderSettings;
}

export class BackOffice extends ProcessComponent<IBackOfficeProps, IBackOfficeState> {
    constructor(props: any) {
        super(props);
        this.state = { providers: [], currentSetting: null };
        this.subscribeToStore(BackOfficeProvidersStore, () =>
            this.setState({ providers: BackOfficeProvidersStore.getData() })
        );
    }

    componentDidMount() {
        super.componentDidMount();
        CompanyWizardAction.getBackOfficeProviders();
    }

    private addBackOffice() {
        if (this.props.data.length >= ValidatorContents.MaxBackOfficeProvidersNumber) {
            this.setState({
                currentSetting: null,
            });
        } else {
            this.setState({
                currentSetting: this.getEmptyBackOfficeProvider(),
            });
        }
    }
    getEmptyBackOfficeProvider(): BackOfficeProviderSettings {
        return {
            BackOfficeProviderId: null,
            BulkContractEnquiry: {
                Frequency: {
                    Mon: true,
                    Tue: true,
                    Wed: true,
                    Thu: true,
                    Fri: true,
                    Sat: false,
                    Sun: false,
                },
                StartDate: null,
                FileFormat: FileFormat.Csv,
                LastDate: null,
            },
        };
    }

    private onBackOfficeChange(changes: BackOfficeProviderSettings) {
        const { data } = this.props;
        this.setState({ currentSetting: null });
        if (data.some((x) => x.BackOfficeProviderId == changes.BackOfficeProviderId)) {
            this.props.onChange(
                data.map((x) => (x.BackOfficeProviderId == changes.BackOfficeProviderId ? changes : x))
            );
        } else {
            this.props.onChange([...data, changes]);
        }
    }

    render() {
        const { data } = this.props;
        const { providers } = this.state;
        return (
            <>
                {this.props.isReview == true && <h2>Back office provider settings</h2>}

                {this.props.isReview == false && SectionHeader("Back office provider settings") && (
                    <div className="row narrow-gutter row-right vspace-24">
                        <div className="col-auto"></div>
                        <div className="col-auto">
                            <button
                                className="btn small secondary"
                                onClick={() => this.addBackOffice()}
                                disabled={data.length >= 3}
                            >
                                Add back office provider settings
                            </button>
                        </div>
                    </div>
                )}
                {providers && providers.length > 0 && (
                    <>
                        {" "}
                        {data && data.length > 0 && (
                            <Table
                                data={data}
                                col={[
                                    {
                                        title: "Back office provider system",
                                        render: (data, row: BackOfficeProviderSettings, index) => {
                                            return this.state.providers.find(
                                                (x) => x.ProviderId == row.BackOfficeProviderId
                                            ).BackOfficeProviderDisplayName;
                                        },
                                    },
                                    {
                                        title: "Start date",
                                        render: (data, row: BackOfficeProviderSettings, index) => {
                                            return JsonDateParser.getFormatDateString(
                                                JsonDateParser.toDate(row.BulkContractEnquiry?.StartDate),
                                                "dd-MM-yyyy",
                                                true,
                                                true
                                            );
                                        },
                                    },
                                    {
                                        title: "Last date",
                                        render: (data, row: BackOfficeProviderSettings, index) => {
                                            const lastDate = JsonDateParser.toDate(row.BulkContractEnquiry?.LastDate);
                                            return lastDate
                                                ? JsonDateParser.getFormatDateString(lastDate, "dd-MM-yyyy", true, true)
                                                : null;
                                        },
                                    },
                                    {
                                        title: "",
                                        render: (ele, row, index) => {
                                            return (
                                                this.props.isReview == false && (
                                                    <>
                                                        <button
                                                            className={
                                                                this.props.isReview
                                                                    ? "btn secondary mr-10"
                                                                    : "edit-circle-icon-button label-sr-only mr-2"
                                                            }
                                                            title={this.props.isReview ? "" : "Edit"}
                                                            onClick={() => this.setState({ currentSetting: row })}
                                                        >
                                                            {this.props.isReview ? null : (
                                                                <span className="icon" aria-hidden="true"></span>
                                                            )}
                                                            {this.props.isReview ? (
                                                                "View"
                                                            ) : (
                                                                <span className="text">Edit</span>
                                                            )}
                                                        </button>

                                                        <button
                                                            className="remove-button label-sr-only"
                                                            title="Delete"
                                                            disabled={this.props.isReview}
                                                            onClick={() => {
                                                                const _data = data;
                                                                if (
                                                                    this.state.currentSetting &&
                                                                    this.state.currentSetting.BackOfficeProviderId ==
                                                                        _data[index].BackOfficeProviderId
                                                                ) {
                                                                    this.setState({ currentSetting: null });
                                                                }
                                                                _data.splice(index, 1);
                                                                this.props.onChange(_data);
                                                            }}
                                                        >
                                                            <span className="icon" aria-hidden="true"></span>
                                                            <span className="text">Delete</span>
                                                        </button>
                                                    </>
                                                )
                                            );
                                        },
                                    },
                                ]}
                            />
                        )}
                        {this.state.currentSetting && (
                            <div className="row">
                                <div className="col-xs-12 col-sm-7">
                                    <BackOfficeSettings
                                        isReview={this.props.isReview}
                                        data={this.state.currentSetting}
                                        acornCommissionSettings={this.props.acornCommissionSettings}
                                        providers={this.state.providers}
                                        onRef={(ref) => {
                                            this.appendChild(ref);
                                        }}
                                        onChange={() => {}}
                                        onSave={(changes) => this.onBackOfficeChange(changes)}
                                        onCancel={() => this.setState({ currentSetting: null })}
                                    />
                                </div>
                            </div>
                        )}
                    </>
                )}
            </>
        );
    }
}
